import React from 'react'

import PropTypes from 'prop-types'
import makeStyles from '@mui/styles/makeStyles'

import TextField from '@mui/material/TextField'

import PasswordField from './PasswordField'

const useStyles = makeStyles(
  theme => ({
    spaceBelow: {
      marginBottom: theme.spacing(2)
    }
  }),
  {
    name: 'LoginFields'
  }
)

const EMAIL_HELPER_TEXT =
  'This email is not editable for privacy reasons. If you’d like to use a different email, please contact the sender.'

const LoginFields = props => {
  const { model, hideEmail, readOnlyEmail, onChange } = props

  const handleChange = event => {
    onChange({
      [event.target.name]: event.target.value
    })
  }

  const classes = useStyles(props)
  return (
    <>
      {!hideEmail && (
        <TextField
          className={classes.spaceBelow}
          variant="filled"
          name="username"
          label="Email"
          type="email"
          disabled={Boolean(readOnlyEmail)}
          helperText={readOnlyEmail && EMAIL_HELPER_TEXT}
          InputProps={{
            autoComplete: readOnlyEmail ? 'off' : 'email',
            readOnly: Boolean(readOnlyEmail)
          }}
          // Set the default value of the email field with the value of 'model.username' prop,
          // because some browsers do not identify autofill values, so we need to set the default value manually,
          // if there is no default value then it will be an empty string.
          defaultValue={model.username}
          onChange={handleChange}
          fullWidth
        />
      )}

      <PasswordField
        variant="filled"
        name="password"
        label="Password"
        autoComplete="current-password"
        // Set the default value of the password field with the value of 'model.password' prop,
        // because some browsers do not identify autofill values, so we need to set the default value manually,
        // if there is no default value then it will be an empty string.
        defaultValue={model.password}
        onChange={handleChange}
        fullWidth
      />
    </>
  )
}

LoginFields.propTypes = {
  model: PropTypes.object.isRequired,
  hideEmail: PropTypes.bool, // Used when accepting invitations.
  readOnlyEmail: PropTypes.bool, // Ditto, but if we still want the email to be visible.
  onChange: PropTypes.func.isRequired
}

export default LoginFields
